<template>
  <div>
    <v-text-field
      :value="value"
      label="Buscar..."
      outlined dense
      hide-details
      @input="search"
    >
      <template v-slot:prepend-inner>
        <v-icon>mdi-magnify</v-icon>
      </template>
    </v-text-field>
  </div>
</template>

<script>
export default {
  name: 'quicksearch',
  props: {
    value: {
      type: String
    },
    immediate: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    timeout: null
  }),
  methods: {
    search (val) {
      if (this.immediate) {
        this.$emit('input', val)
      } else {
        if (this.timeout) clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.$emit('input', val)
        }, 700)
      }
    }
  }
}
</script>
